import axios from "axios";
import { useState } from "react";
import ConnectionVisiteur from "../../Views/Utilisateure/visiteur/ConnectionVisiteur";
import { useNavigate } from "react-router-dom";

export default function ConnectionVisiteurService() {
  const [Tele, setTele] = useState<any>("");
  const [Password, setPassword] = useState("");
  const [ShowEreurPopup, setShowEreurPopup] = useState<any>(false);
    const navigate=useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_PHP_APP_URL}/connection-visiteur`;

    try {
      const response = await axios.post(
        url,
        { Tele, Password },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      localStorage.setItem("VisiteurId", response.data.account.id);
      localStorage.setItem("VisiteurName", response.data.account.Nom_Complet);
      localStorage.setItem("VisiteurAdresse", response.data.account.Adresse);
      localStorage.setItem("VisiteurTele", response.data.account.Tele);
      navigate('/visiteurs')
    } catch (error: any) {
      console.error("Erreur de connexion:", error);
      setShowEreurPopup(true);
        const timeoutId = setTimeout(() => {
        setShowEreurPopup(false);
        }, 2000);
      // alert("Échec de la connexion. Vérifiez le numéro et le mot de passe.");
    }
  };

  return (
    <>
      <ConnectionVisiteur
        ShowEreurPopup={ShowEreurPopup}
        setShowEreurPopup={setShowEreurPopup}
        Tele={Tele}
        setTele={setTele}
        Password={Password}
        setPassword={setPassword}
        handleSubmit={handleSubmit}
        />
    </>
  );
}
